{
  "title": "Cheques",
  "detailTitle": "Cheque {{number}}",
  "subtitle": {
    "RECEIVED": "Cheques from customers, from the safe to the bank",
    "ISSUED": "Cheques written to suppliers, until the bank pays them"
  },
  "sides": {
    "label": "Cheques received or issued",
    "RECEIVED": "Received",
    "ISSUED": "Issued"
  },
  "kind": {
    "RECEIVED": "Cheque received",
    "ISSUED": "Cheque issued"
  },
  "views": {
    "label": "Cheque views",
    "open": "Open",
    "cleared": "Cleared",
    "bounced": "Bounced",
    "closed": {
      "RECEIVED": "Handed back",
      "ISSUED": "Cancelled"
    },
    "all": "All"
  },
  "searchPlaceholder": "Search number, bank, party…",
  "searchLabel": "Search cheques",
  "filters": {
    "account": "Account"
  },
  "fields": {
    "number": "Cheque no.",
    "chequeDate": "Cheque date",
    "supplier": "Supplier",
    "receipt": "Receipt",
    "payment": "Payment",
    "depositAccount": "Deposit account",
    "drawnOn": "Drawn on",
    "amount": "Amount",
    "status": "Status",
    "bank": "Bank",
    "depositedOn": "Deposited on",
    "clearedOn": "Cleared on"
  },
  "status": {
    "IN_HAND": "In hand",
    "DEPOSITED": "Deposited",
    "ISSUED": "Issued",
    "CLEARED": "Cleared",
    "BOUNCED": "Bounced",
    "RETURNED": "Handed back",
    "CANCELLED": "Cancelled"
  },
  "due": {
    "OVERDUE": "Date passed",
    "TODAY": "Due today",
    "SOON": "Due this week",
    "LATER": "Post-dated"
  },
  "dueDeposited": {
    "OVERDUE": "Late to clear",
    "TODAY": "Clears today",
    "SOON": "At the bank",
    "LATER": "At the bank"
  },
  "postDated": "Post-dated",
  "postDatedBy": "Post-dated: the bank takes it from {{date}}.",
  "figures": "Cheque figures",
  "actions": {
    "deposit": "Deposit",
    "clear": "Mark cleared",
    "bounce": "Bounced",
    "return": "Hand back",
    "cancel": "Cancel cheque",
    "chargeback": "Returned by the bank",
    "undo": "Undo last step"
  },
  "rowActions": "Actions for cheque {{number}}",
  "select": "Select cheque {{number}}",
  "notSelectable": "Nothing to deposit or clear",
  "bulk": {
    "deposit_one": "Deposit {{n}} cheque",
    "deposit_other": "Deposit {{n}} cheques",
    "depositHint": "Only cheques in hand whose date has come can be deposited",
    "clear_one": "Mark {{n}} cleared",
    "clear_other": "Mark {{n}} cleared",
    "clearHint": "Only open cheques can be marked cleared"
  },
  "toast": {
    "deposit": "Cheque {{number}} deposited",
    "clear": "Cheque {{number}} cleared",
    "bounce": "Cheque {{number}} recorded as bounced",
    "return": "Cheque {{number}} handed back",
    "cancel": "Cheque {{number}} cancelled",
    "chargeback": "Cheque {{number}} recorded as returned by the bank",
    "undo": "Last step of cheque {{number}} undone",
    "depositMany_one": "{{count}} cheque deposited",
    "depositMany_other": "{{count}} cheques deposited",
    "clearMany_one": "{{count}} cheque cleared",
    "clearMany_other": "{{count}} cheques cleared"
  },
  "dialog": {
    "depositTitle": "Deposit cheque {{number}}",
    "clearTitle": "Mark cheque {{number}} cleared",
    "bounceTitle": "Cheque {{number}} bounced",
    "returnTitle": "Hand back cheque {{number}}",
    "cancelTitle": "Cancel cheque {{number}}",
    "chargebackTitle": "Cheque {{number}} returned by the bank",
    "undoTitle": "Undo the last step of cheque {{number}}",
    "depositManyTitle_one": "Deposit {{count}} cheque ({{amount}})",
    "depositManyTitle_other": "Deposit {{count}} cheques ({{amount}})",
    "clearManyTitle_one": "Mark {{count}} cheque cleared ({{amount}})",
    "clearManyTitle_other": "Mark {{count}} cheques cleared ({{amount}})",
    "depositBody": {
      "RECEIVED": "The money stays under collection until the bank pays the cheque; nothing is posted yet.",
      "ISSUED": "Issued cheques are presented by the supplier."
    },
    "clearBody": {
      "RECEIVED": "The bank paid it: the amount moves from cheques under collection into the bank account.",
      "ISSUED": "The bank paid it out: the amount leaves the bank account it was drawn on."
    },
    "bounceBody": {
      "RECEIVED": "The receipt is voided as of this date, so the customer owes the amount again. This cannot be undone; record a replacement cheque afterwards.",
      "ISSUED": "The payment is voided as of this date, so the supplier is owed the amount again. This cannot be undone."
    },
    "returnBody": {
      "RECEIVED": "The cheque goes back to the customer and its receipt is voided as of this date. This cannot be undone.",
      "ISSUED": "Issued cheques are cancelled, not handed back."
    },
    "cancelBody": {
      "RECEIVED": "Received cheques are handed back, not cancelled.",
      "ISSUED": "The cheque was stopped or torn up: its payment is voided as of this date. This cannot be undone."
    },
    "chargebackBody": {
      "RECEIVED": "The bank paid this cheque and has now taken the money back. Its clearing stays as it was (it may be reconciled on a bank statement): a new entry on this date takes the amount out of the bank account, to match on the statement that shows it. The receipt is voided as of this date, so the customer owes the amount again. This cannot be undone.",
      "ISSUED": "The bank paid this cheque out and has now put the money back. Its clearing stays as it was: a new entry on this date puts the amount back in the bank account, to match on the statement that shows it. The payment is voided as of this date, so the supplier is owed the amount again. This cannot be undone."
    },
    "undoBody": {
      "RECEIVED": "Takes back the last deposit or clearing, recorded by mistake. A clearing's entry is reversed on its own date.",
      "ISSUED": "Takes back the clearing, recorded by mistake. Its entry is reversed on its own date."
    },
    "date": {
      "deposit": "Deposit date",
      "clear": "Cleared on",
      "bounce": "Bounced on",
      "return": "Handed back on",
      "cancel": "Cancelled on",
      "chargeback": "Returned on"
    },
    "reason": {
      "bounce": "Bank's reason",
      "return": "Why it was handed back",
      "cancel": "Why it was cancelled",
      "chargeback": "Bank's reason",
      "undo": "Why it is undone"
    },
    "bank": "Bank account",
    "chooseBank": "Choose a bank account",
    "reasonShort": "Give a reason (at least 3 characters)",
    "postDatedHint": "Dated {{date}}: the bank takes it from that day.",
    "chargebackHint": "Cleared on {{date}}: the bank's return is dated that day or later, and after the last completed bank statement."
  },
  "errors": {
    "CHEQUE_STATUS": "This cheque has moved on since the page was opened. Reload to see where it stands.",
    "CHEQUE_NOT_DUE": "A cheque cannot be deposited or paid before the date written on it.",
    "CHEQUE_CLEARED": "The bank already paid this cheque. On the cheque, undo its clearing (a mistake) or record that the bank returned it.",
    "SOURCE_REFUNDED": "A refund was paid out of this cheque's receipt or payment. Void the refund first.",
    "CUSTOMER_ARCHIVED": "This customer is archived. Restore them first: the receipt is voided, so they owe the amount again.",
    "SUPPLIER_ARCHIVED": "This supplier is archived. Restore them first: the payment is voided, so they are owed the amount again.",
    "BANK_LINE_MATCHED": "The clearing is matched on bank statement {{number}}. If the bank took the money back, use “Returned by the bank” instead; a clearing recorded by mistake is unmatched on the statement first.",
    "BANK_LINE_MATCHED_completed": "The clearing is reconciled on bank statement {{number}}, which is completed. If the bank took the money back, use “Returned by the bank” instead: the statement stays as it was.",
    "VERSION_CONFLICT": "Someone else changed this cheque. Reload and try again."
  },
  "stats": {
    "label": "Cheque figures",
    "cheques_one": "{{n}} cheque",
    "cheques_other": "{{n}} cheques",
    "due": {
      "RECEIVED": "To deposit",
      "ISSUED": "Due for payment"
    },
    "week": "Due this week",
    "postDated": "Post-dated",
    "postDatedDetail": "{{cheques}}, {{week}} this week",
    "atBank": "At the bank",
    "atBankLate": "{{cheques}}, {{late}} late to clear",
    "bounced": "Bounced, 30 days"
  },
  "empty": {
    "open": "Nothing waiting",
    "cleared": "No cleared cheques",
    "bounced": "No bounced cheques",
    "closed": "None here",
    "all": "No cheques yet"
  },
  "emptyBody": {
    "RECEIVED": "Cheques appear here when a receipt is recorded with the cheque method and the cheque's details.",
    "ISSUED": "Cheques appear here when a supplier payment is recorded with the cheque method and the cheque's details."
  },
  "closed": {
    "BOUNCED": {
      "title": "Bounced on {{date}}",
      "body": {
        "RECEIVED": "Receipt {{number}} was voided: the customer owes this amount again.",
        "ISSUED": "Payment {{number}} was voided: the supplier is owed this amount again."
      }
    },
    "CHARGEBACK": {
      "title": "Returned by the bank on {{date}}",
      "body": {
        "RECEIVED": "It cleared on {{cleared}}; that clearing stays, and the return is its own movement on the bank account. Receipt {{number}} was voided: the customer owes this amount again.",
        "ISSUED": "It cleared on {{cleared}}; that clearing stays, and the return is its own movement on the bank account. Payment {{number}} was voided: the supplier is owed this amount again."
      }
    },
    "RETURNED": {
      "title": "Handed back on {{date}}",
      "body": {
        "RECEIVED": "Receipt {{number}} was voided.",
        "ISSUED": "Payment {{number}} was voided."
      }
    },
    "CANCELLED": {
      "title": "Cancelled on {{date}}",
      "body": {
        "RECEIVED": "Receipt {{number}} was voided.",
        "ISSUED": "Payment {{number}} was voided."
      }
    }
  },
  "replace": {
    "title": "Replacement",
    "received": "Receive a replacement cheque",
    "issued": "Write a replacement cheque",
    "replaces": "Replaces cheque",
    "replacedBy": "Replaced by cheque"
  },
  "timeline": {
    "title": "What happened",
    "by": "By {{name}}, {{at}}",
    "entry": "Journal entry",
    "RECEIVED": {
      "RECEIVED": "Received with the receipt",
      "ISSUED": "Received"
    },
    "ISSUED": {
      "RECEIVED": "Issued",
      "ISSUED": "Written with the payment"
    },
    "DEPOSITED": {
      "RECEIVED": "Deposited into {{account}}",
      "ISSUED": "Deposited into {{account}}"
    },
    "CLEARED": {
      "RECEIVED": "Cleared: the bank paid it",
      "ISSUED": "Cleared: the bank paid it out"
    },
    "BOUNCED": {
      "RECEIVED": "Bounced: the receipt was voided",
      "ISSUED": "Bounced: the payment was voided"
    },
    "RETURNED": {
      "RECEIVED": "Handed back: the receipt was voided",
      "ISSUED": "Handed back"
    },
    "CANCELLED": {
      "RECEIVED": "Cancelled: the receipt was voided",
      "ISSUED": "Cancelled: the payment was voided"
    },
    "CHARGEBACK": {
      "RECEIVED": "Returned by the bank: the receipt was voided",
      "ISSUED": "Returned by the bank: the payment was voided"
    },
    "UNDONE": {
      "RECEIVED": "Last step undone",
      "ISSUED": "Last step undone"
    }
  },
  "notes": {
    "title": "Follow-up notes",
    "add": "Add",
    "saved": "Notes saved",
    "none": "No notes"
  },
  "capture": {
    "title": "Cheque",
    "description": "Followed up until the bank pays it: the money waits under collection until then.",
    "descriptionIssued": "Followed up until the bank pays it: the payment is owed through cheques issued until then.",
    "number": "Cheque no.",
    "bank": "Drawn on (bank)",
    "date": "Cheque date",
    "postDated": "Post-dated: the bank takes it from {{date}}.",
    "drawnOn": "Drawn on {{account}}.",
    "needsBank": "A cheque is written on a bank account: choose one above.",
    "replaces": "Replaces bounced cheque {{number}}",
    "dropReplaces": "Not a replacement",
    "bouncedBefore_one": "{{n}} cheque of this customer bounced before (the last on {{date}}).",
    "bouncedBefore_other": "{{n}} cheques of this customer bounced before (the last on {{date}}).",
    "see": "See"
  },
  "card": {
    "title": "Cheque",
    "open": "Open cheque"
  },
  "customerTab": {
    "title": "Cheques",
    "figures": "The customer's cheques",
    "register": "Open in the cheque register",
    "bouncedEver": "Bounced, ever",
    "empty": "No cheques from this customer",
    "emptyBody": "Receipts by cheque with the cheque’s details appear here, with what became of each.",
    "list": "The customer's cheques, newest first"
  }
}
